import { withInstall } from '@xzx-design/utils'
import _Tab from './src/tab'

export const Tab = withInstall(_Tab)
export default Tab

export * from './src/types/tab'
